import { Link } from 'react-router';
import clsx from 'clsx';
import Icon from './Icon.jsx';
import styles from './ActionList.module.scss';

export function ActionList({ children, className }) {
  return <div className={clsx(styles.list, className)}>{children}</div>;
}

/** A big, labelled, tappable row with an icon and an optional explanation. */
export function ActionRow({ icon, label, description, onClick, to, danger, disabled, chevron = true, trailing, ...rest }) {
  const inner = (
    <>
      {icon ? (
        <span className={styles.icon}>
          <Icon name={icon} size={20} />
        </span>
      ) : null}
      <span className={styles.text}>
        <span className={styles.label}>{label}</span>
        {description ? <span className={styles.desc}>{description}</span> : null}
      </span>
      {trailing ?? (chevron && to ? <Icon name="chevron" size={18} className={styles.chev} /> : null)}
    </>
  );
  const cls = clsx(styles.row, danger && styles.danger);
  if (to && !disabled) {
    return (
      <Link to={to} className={cls} {...rest}>
        {inner}
      </Link>
    );
  }
  return (
    <button type="button" className={cls} onClick={onClick} disabled={disabled} {...rest}>
      {inner}
    </button>
  );
}

/** Square-ish tappable card used for primary shortcuts. */
export function ActionTile({ icon, label, description, to, onClick, ...rest }) {
  const inner = (
    <>
      <span className={styles.tileIcon}>
        <Icon name={icon} size={22} />
      </span>
      <span className={styles.tileText}>
        <span className={styles.label}>{label}</span>
        {description ? <span className={styles.desc}>{description}</span> : null}
      </span>
    </>
  );
  if (to) {
    return (
      <Link to={to} className={styles.tile} {...rest}>
        {inner}
      </Link>
    );
  }
  return (
    <button type="button" className={styles.tile} onClick={onClick} {...rest}>
      {inner}
    </button>
  );
}

/** `columns` fixes the count at every size; by default it's 2 on phones and 4 on bigger screens. */
export function TileGrid({ children, columns, spread = false }) {
  return (
    <div
      className={clsx(styles.grid, columns && styles.fixed, spread && styles.spread)}
      style={columns ? { '--cols': columns } : undefined}
    >
      {children}
    </div>
  );
}
